import React from 'react'
import { SignContainer, String, OpenCloseText } from './styles'

const OpenClose = ({ value }) => {
	return (
		<SignContainer>
			<String position={'0%'} rotation={'rotate(65deg)'} />
			<String position={'50%'} rotation={'rotate(-65deg)'} />
			<OpenCloseText>{value}</OpenCloseText>
		</SignContainer>
	)
}

export default OpenClose
